import {createBrowserRouter, RouterProvider} from 'react-router-dom'
import {SignIn, ForgotPassword} from "./pages/sign-in";
import {SignedOut} from "./pages/sign-in/SignedOut";
import {ForgotPasswordForm} from "./pages/sign-in/components/ForgotPasswordForm";
import { AdvisorOnboardingForm } from './pages/advisor-invitations/Onboarding/AdvisorOnboardingForm';
import { MfaAttempts } from './pages/advisor-invitations/MFA/MfaAttempts';
import { MfaVerification } from './pages/advisor-invitations/MFA/MfaVerification';
import { CreatePasswordAndSecurity } from './pages/advisor-invitations/CreatePasswordAndSecurity/CreatePasswordAndSecurity';
import Demise from './pages/sign-in/components/demise';
import {AdviseeMfaAttempts} from "./pages/advisee-password-invitations/AdviseeMfaAttempts";
import {AdviseeMfaVerification} from "./pages/advisee-password-invitations/AdviseeMfaVerification";
import {AdviseeSetPassword} from "./pages/advisee-password-invitations/AdviseeSetPassword";
import {HelpPageLayout} from "./pages/help/HelpPageLayout";
import {HelpHome} from "./pages/help/HelpHome";
import {HELP_HOME, HELP_PAGES} from "./pages/help/helpPages";


function App() {
    const routes = [
        {
            path: "/forgot-password",
            element: <ForgotPasswordForm/>
        },
        {
            path: "/forgot-password-continuation",
            element: <ForgotPassword/>
        },
        {
            path: "/signed-out",
            element: <SignedOut/>
        },
        {
            path: "*",
            element: <SignIn/>
        },
        {
            path: "/advisor-invitations/:repId/onboarding",
            element: <AdvisorOnboardingForm/>
        },
        {
            path: "/advisor-invitations/mfa-attempts/:repId",
            element: <MfaAttempts/>
        },
        {
            path: "/advisor-invitations/:repId/mfa-verification",
            element: <MfaVerification/>
        },
        {
            path: "/advisor-invitations/:repId/create-password",
            element: <CreatePasswordAndSecurity/>
        },
        {
            path: "/demise",
            element: <Demise/>
        },
        {
            path: "/create-password",
            element: <AdviseeMfaAttempts/>
        },
        {
            path: "/create-password/:token/mfa-verification",
            element: <AdviseeMfaVerification/>
        },
        {
            path: "/create-password/:token/set-password",
            element: <AdviseeSetPassword/>
        }
    ];

    const helpRoutes = [{
        path: HELP_HOME,
        element: <HelpPageLayout/>,
        children: [
            {index: true, element: <HelpHome/>},
            ...HELP_PAGES.map(({path, Page}) => ({path, element: <Page/>})),
        ],
    }];
    // Cross-app links use native anchors so sign-in keeps its existing router basename.
    const isHelp = /^\/help(?:\/|$)/i.test(window.location.pathname);
    const router = createBrowserRouter(isHelp ? helpRoutes : routes, {basename: isHelp ? '/' : '/sign-in'});
    return (
        <RouterProvider router={router}/>
    );
}

export default App;
